import React from 'react';
import EventComponent from '../Components/EventComponent'; 
import Topbar from '../Components/Topbar'
import './DisplayEvent.css';



function MyEvents() {
  return (
    <div className="bg-[#F7F8FC] w-[100%] overflow-y-scroll rounded-xl">
      <Topbar/>
      <div className="bg-white px-[3%] mx-[3%] py-[1%] mb-[5%] mt-[2%]">
        <div className="mt-[15px] pt-[10px] mx-[0%]">
            <p className="text-black text-[28px] font-semibold ml-[0%] pb-[0px]">Event List</p>
        </div>
        <EventComponent my={true}/>
      </div>
    </div>
  );
}

export default MyEvents;
